import { render, staticRenderFns } from "./LegacyContextKAssign.vue?vue&type=template&id=6e1646a2&scoped=true&"
import script from "./LegacyContextKAssign.vue?vue&type=script&lang=js&"
export * from "./LegacyContextKAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1646a2",
  null
  
)

export default component.exports